import i18next from 'i18next';

i18next.addResources('es', 'sectionSelector', {
  allSections: 'Todas',
  sections: 'Secciones',
  project: 'Proyectos',
  article: 'Contenidos',
  event: 'Eventos'
});
